
import { AxiosHelper } from '../helpers/AxiosHelper';


const List = async (formData: FormData) => {
    return AxiosHelper.post('/Department/List', formData);
}

const AddEdit = async (formData: FormData) => {
    return AxiosHelper.post('/Department/AddEdit', formData);
}

const Remove = async (formData: FormData) => {
    return AxiosHelper.post('/Department/Remove', formData);
}


const DepartmentService = {
    List,
    AddEdit,
    Remove
}

export default DepartmentService;